import { IIsiDtoMenuObject } from "../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiActionContext } from "../../Core/IsiActionContext";

/**
 * Configuration de la IsiPopin de selection d'instance
 * sur l'ajout d'une donnée associée
 */
export class  IsiAddInstancePopin {

    public static showPopin(listAddEntries: IIsiDtoMenuObject[], actionContext: IsiActionContext) {
        const popinCmp = uiCore.getIsiPopin();
        let html = ""
        for (const dto of listAddEntries) {
            if (dto.id !== DATA_ADDv2) {
                html += `<option value='${dto.id}'>${dto.shortLabel}</option>`;
            }
        }
        
        popinCmp.resetDefaultSettings();
        popinCmp.updateDtoProperty("upperBarTitle", uiCore.getMessage("GLOB032", 'ADDITEM').IsiLabel);
        if (uiCore.isRWDTablet()) {
            popinCmp.updateDtoProperty("contentContainerMinHeight", 166);
        } else {
            popinCmp.updateDtoProperty("contentContainerMinHeight", 213);
        }
        
        popinCmp.getExternalContentContainer().html(`<div class="infosComplPopin">
                                                                           <div class="control IsiTextConnexe max-width-t"><span tabindex="-1" class="tcL">${uiCore.getMessage("GLOB032", 'ADDA').IsiLabel}</span></div>
                                                                           <div class="tcD tcDEna iActiveFocus"><select class="tcTb iCtrlEna">${html}</select></div></div>`);
        popinCmp.updateDtoProperty("showContentContainerBottomArrow", false);
        popinCmp.updateDtoProperty("contentContainerVerticalPositionning", "middle");
        popinCmp.RemoveCloseOnVeilClick();
        popinCmp.addCustomClass("IsiInstanceSelection");
        popinCmp.setBottomBarButtons({
            template: popinCmp.BOTTOMBAR_BUTTONS_TEMPLATE.VALIDATE,
            onClickHandler: () => {
                const action = uiCore.getIsiPopin().getJQueryChildrenElement(".infosComplPopin").find(":selected").val();
                if (action !== "") {
                    uiCore.onClick(null, actionContext.uiAction.menuBarId + MNU_SEP + DATA_MNUGRP_NAVIGATION + MNU_SEP + action, null);
                } else {
                    return false;
                }
                
            }
        }, {
            template: popinCmp.BOTTOMBAR_BUTTONS_TEMPLATE.CANCEL,
            onClickHandler: () => {
                //on ne fait rien   
            }
        });
        popinCmp.refreshElements();
        popinCmp.show();
    }

}
